import React from 'react';
import Icon from '../../../components/AppIcon';

const FilterBar = ({ 
  activeFilter, 
  onFilterChange, 
  activeTimeFilter, 
  onTimeFilterChange,
  totalCount 
}) => {
  const contentFilters = [
    { value: 'all', label: 'Todos', icon: 'Grid' },
    { value: 'arts', label: 'Artes', icon: 'Image' },
    { value: 'videos', label: 'Vídeos', icon: 'Video' }
  ];

  const timeFilters = [
    { value: 'all-time', label: 'Todo Período' },
    { value: 'month', label: 'Este Mês' },
    { value: 'week', label: 'Esta Semana' }
  ];

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 glow-primary">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-md bg-primary/10 flex items-center justify-center glow-primary">
            <Icon name="Filter" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="text-base md:text-lg font-heading font-bold text-foreground">
              Filtros
            </h3>
            <p className="text-xs md:text-sm text-muted-foreground">
              {totalCount} conteúdos em destaque
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
          <div className="flex items-center gap-2 overflow-x-auto">
            {contentFilters?.map((filter) => (
              <button
                key={filter?.value}
                onClick={() => onFilterChange(filter?.value)}
                className={`flex items-center gap-2 px-3 py-2 md:px-4 md:py-2 rounded-md font-medium text-xs md:text-sm whitespace-nowrap transition-smooth flex-shrink-0 ${
                  activeFilter === filter?.value
                    ? 'bg-primary text-primary-foreground glow-primary'
                    : 'bg-muted text-foreground hover:bg-muted/80 hover:glow-primary-hover'
                }`}
              >
                <Icon name={filter?.icon} size={16} />
                <span>{filter?.label}</span>
              </button>
            ))}
          </div>

          <div className="flex items-center gap-2 overflow-x-auto">
            {timeFilters?.map((filter) => (
              <button
                key={filter?.value}
                onClick={() => onTimeFilterChange(filter?.value)}
                className={`px-3 py-2 md:px-4 md:py-2 rounded-md font-medium text-xs md:text-sm whitespace-nowrap transition-smooth flex-shrink-0 ${
                  activeTimeFilter === filter?.value
                    ? 'bg-secondary text-secondary-foreground glow-secondary'
                    : 'bg-muted text-foreground hover:bg-muted/80 hover:glow-secondary-hover'
                }`}
              >
                {filter?.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;